import { Component } from '@angular/core';

@Component({
  selector: 'forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: [ '../status.less' ],
})
export class ForbiddenComponent {}
